module.exports = __webpack_public_path__ + "img/airpay.f7a75d32.png";